<template>
<svg id="burger-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 23.3"><defs></defs><title>Asset 1</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-15" width="34" height="3.3"/><polygon class="cls-15" points="34 13.3 10.3 13.3 0 13.3 0 10 34 10 34 13.3"/><rect class="cls-15" y="20" width="34" height="3.3"/></g></g></svg>
</template>
<script>
export default{
  name: 'burger'
}
</script>
<style lang="scss">
.cls-15{fill:#fff;}


#burger-svg{
      width: 40px;
      cursor: pointer;
}



</style>